module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/mario-6fced804abb72d0a295d1111bcecc26d.jpg";